// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609010404/js/" + chunkId + "." + {"44":"d1ff83bc","225":"dc68bd5f","481":"3ea99fb8","486":"275ce3a1","770":"00fdc6a6"}[chunkId] + ".0.4168053765553066.chunk.js";
};